import {
  Component 
} from "react"

import getDisplayName from "@/util/getDisplayName"
import mergeClasses from "@/util/shallowMerge"

const classify = (defaultClasses) => (WrappedComponent) => class extends Component {
        static displayName = `Classify(${getDisplayName(WrappedComponent)})`

        render() {
          const {
            className, classes, ...restProps 
          } = this.props
          const classNameAsObject = className ? {
            root: className 
          } : null
          const finalClasses = mergeClasses(
            defaultClasses,
            classNameAsObject,
            classes
          )

          return <WrappedComponent {...restProps} classes={finalClasses} />
        }
}

export {
  mergeClasses, mergeClasses as useStyle 
}

export default classify
